import * as ApiRequests from '../../api/requests';
import { AuthHelper, DeviceProfileData } from '../../types';
import { AppThunk } from '../actions';
import { ManageDeviceProfilesActions } from '../actions/manage-device-profiles-actions';

export const ManageDeviceProfilesThunks = {
    SaveDeviceProfile: (
        deviceProfileData: DeviceProfileData,
        organizationId: string,
        authHelper: AuthHelper,
        addToast: Function
    ): AppThunk => async (dispatch): Promise<void> => {
        dispatch(ManageDeviceProfilesActions.DeviceProfileSaveStarted());

        const payload = await ApiRequests.saveDeviceProfile(
            {
                organizationId: organizationId,
                parentDeviceProfileId: deviceProfileData.parentDeviceProfileId,
                displayName: deviceProfileData.displayName,
                profileName: deviceProfileData.profileName,
                newChannels: deviceProfileData.newChannels,
                existingChannels: deviceProfileData.existingChannels,
            },
            { authHelper }
        );

        if (payload.ok) {
            dispatch(
                ManageDeviceProfilesActions.DeviceProfileSaveSucceeded(payload.response.message, payload.response.data)
            );
        } else {
            const errorCode = ApiRequests.extractResponseNotOkCode(payload.response);

            addToast(ApiRequests.extractResponseNotOkMessage(payload.response), 'error');
            if (errorCode === 4001) {
                addToast(ApiRequests.extractResponseNotOkMessage(payload.response), 'error');
            }
            dispatch(ManageDeviceProfilesActions.DeviceProfileSaveFailed(errorCode.toString()));
        }
    },
};
